<template>
    <div class="operate-wrap">
        <div class="time-box">
            <SingleCalendar @dateSelect="setDateStart" class="time-start" :config="calendarConfig" :value="customDate.startTime" />
            <span class="span-fgf"></span>
            <SingleCalendar @dateSelect="setDateEnd" class="time-end" :config="calendarConfig" :value="customDate.endTime" />
        </div>
        <LangSelect :value="lang" @change="langSelect" class="lang-select" :requireAll="true"></LangSelect>
        <ChannelSelect class="channel-select" value="all" @change="channelChange" />
        <Search :placeholder="placeholder" class="question-search" @searchChange="searchChange" @inputChange="searchChange"></Search>
    </div>
</template>

<script>
import ChannelSelect from "@/views/zhiji/components/channelSelect/index";
import LangSelect from "@/components/langSelect";
import Search from "@/views/zhiji/bComponents/inputs/Search";
import SingleCalendar from "@/views/zhiji/bComponents/calendar/SingleCalendar";
import { debounce } from "@/views/zhiji/js/common/util.js";

export default {
    name: "TopOperateBar",
    components: {
        Search,
        SingleCalendar,
        LangSelect,
        ChannelSelect
    },
    data() {
        return {
            calendarConfig: {
                position: "left",
                hasRadius: true,
                dateFormat: "YYYY/MM/DD hh:mm"
            },
            customDate: {
                startTime: new Date(this.zhiji.dateFormat(new Date(), "YYYY-MM-DD 00:00")),
                endTime: new Date()
            },
            channelType: "all",
            keyWord: "",
            lang: "all"
        };
    },
    computed: {
        placeholder() {
            return this.$t("zhiji.common.inputHolderLabel");
        }
    },
    mounted() {
        this.queryHanlder = debounce(function(data) {
            this.keyWord = data[0].value;
            this.updateQueryParams();
        }, 500);
    },
    methods: {
        setDateStart(date) {
            this.customDate.startTime = new Date(this.zhiji.dateFormat(date));
            this.updateQueryParams();
        },
        setDateEnd(date) {
            this.customDate.endTime = new Date(this.zhiji.dateFormat(date));
            this.updateQueryParams();
        },
        channelChange(data) {
            this.channelType = data;
            this.updateQueryParams();
        },
        searchChange(data) {
            this.queryHanlder(data);
        },
        updateQueryParams() {
            let reqData = {
                startDate: this.zhiji.dateFormat(this.customDate.startTime),
                endDate: this.zhiji.dateFormat(this.customDate.endTime),
                channel: this.channelType,
                keyWord: this.keyWord,
                lang: this.lang === "all" ? "" : this.lang
            };
            this.$emit("updateQueryData", reqData);
        },
        langSelect(data) {
            this.lang = data;
            this.updateQueryParams();
        }
    }
};
</script>

<style scoped lang="scss">
.operate-wrap {
    padding: 16px 40px 16px 16px;
    background: #fff;
    display: flex;
    flex-shrink: 0;

    .time-box {
        display: flex;
        align-items: center;
        margin: 0;

        .span-fgf {
            background: #e1eaf2;
            width: 12px;
            height: 1px;
            margin: 0 5px;
        }

        .time-start,
        .time-end {
            width: 170px;
            height: 32px;
        }
    }
    .channel-select {
        margin-left: 8px;
        margin-right: 8px;
        width: 140px;
    }
    .question-search {
        width: 318px;
    }
    .lang-select {
        width: 120px;
        margin-left: 24px;
    }
}
</style>
